import { render, staticRenderFns } from "./ClaimTechExpertForm.vue?vue&type=template&id=028b9748&scoped=true"
import script from "./ClaimTechExpertForm.vue?vue&type=script&lang=js"
export * from "./ClaimTechExpertForm.vue?vue&type=script&lang=js"
import style0 from "./ClaimTechExpertForm.vue?vue&type=style&index=0&id=028b9748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028b9748",
  null
  
)

export default component.exports